// Copyright (c) StrangeBee 2023

import { StatusContext } from '@Context/StatusProvider';
import { useLocalMessage } from '@Helpers/locale';
import { AlertImport } from '@Molecules/AlertImport/AlertImport';
import FileImport from '@Molecules/FileImport/FileImport';
import React, { ReactElement, useContext } from 'react';

interface TaxonomyImportProps {
    onSubmit: (formData: FormData) => Promise<void>;
}

const TaxonomyImport = ({ onSubmit }: TaxonomyImportProps): ReactElement => {
    const i = useLocalMessage();
    const { version } = useContext(StatusContext);

    return (
        <FileImport
            onSubmit={onSubmit}
            drawerTitle={i('taxonomy.import.title')}
            buttonLabel={i('taxonomy.import.label')}
            accept=".json,.zip"
            header={
                <AlertImport title={i('taxonomy.import.header.title')}>
                    <>
                        {i('taxonomy.import.header.download')}{' '}
                        <a href={`https://github.com/MISP/misp-taxonomies/archive/main.zip?version=TheHive-${version}`}>
                            {i('taxonomy.import.header.link')}
                        </a>
                    </>
                </AlertImport>
            }
            uploadTitle={i('taxonomy.import.upload.title')}
            uploadSubtitle={i('taxonomy.import.upload.subtitle')}
            footerLabel={i('taxonomy.import.footer')}
        />
    );
};

export default TaxonomyImport;
